import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: true,
  isDataChanged: false,
  reloadPage: false,
  data: {
    isStudying: false,
    employmentStatusCode: "",
    job: "",
    jobDescription: "",
    jobCompanyName: "",
    phoneNumber: "",
    address: "",
    employmentDescription: "",
    economicLevelCode: "",
    residenceStatusCode: "",
    haveACar: false,
    haveTutelage: false,
    haveTutelageDescription: "",
    carDescription: "",
  },
};

export const FinancialInformationSlice = createSlice({
  name: "financialInformation",
  initialState,
  reducers: {
    updateFinancialInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value !== undefined) {
        if (value.length === 0) {
          if (required) {
            state.data[key] = value;
          } else {
            delete state.data[key];
          }
        } else {
          state.data[key] = value;
        }
      }
    },
    setIsDataChangedForFinancial: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForFinancialInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setFinancialInformationData: (state, { payload }) => {
      state.isDataChanged = false;
      state.isNew = false;
      state.data = payload;
    },
    clearFinancialInformationData: () => initialState,
    setReloadFinancialInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});
export const {
  updateFinancialInformationData,
  setIsNewForFinancialInformation,
  setFinancialInformationData,
  setIsDataChangedForFinancial,
  clearFinancialInformationData,
  setReloadFinancialInformationData,
} = FinancialInformationSlice.actions;
export const FinancialInformationReducer = FinancialInformationSlice.reducer;
